


import React, { useState, useEffect } from "react";
import { Card, Col, Table, Row, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { TableLoaderRow, TableEmptyRow } from "../components/TableLoader";
import Pagination from "../components/Pagination";
import PageTitle from "../layouts/PageTitle";
import ConfirmationDeleteAccount from "../components/Modal/ConfirmationDeleteAccount";
import { getEvent } from "../../services/UserServices/UserService";
import { EVENT_NAME } from "../../utils/events";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { ChevronRight } from "lucide-react";

const TruncatedTooltipText = ({ text, limit = 40 }) => {
  if (!text) return "--";

  const isLong = text.length > limit;
  const displayText = isLong ? text.slice(0, limit) + "..." : text;

  return isLong ? (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>{text}</Tooltip>}
    >
      <span
        style={{
          cursor: "pointer",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "inline-block",
          maxWidth: "250px",
        }}
      >
        {displayText}
      </span>
    </OverlayTrigger>
  ) : (
    <span>{text}</span>
  );
};

export default function JobPosting() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("");
  const [deleteAccount, setDeleteAccount] = useState(false);
  const [jobId, setJobId] = useState(null);
  const [event, setEvent] = useState([]);

  const [totalItems, setTotalItems] = useState(0);
  // Filters
  const [filterDate, setFilterDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filterType, setFilterType] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");

  const getEvents = async () => {
    try {
      setLoader(true);
      const response = await getEvent(currentPage, 10, filterType, filterDate, endDate, sortBy, sortBy ? sortOrder : "");


      const mappedEvents = response?.data?.data?.events.map((response) => {

        const matchEvent = EVENT_NAME.find((event) => event.id === response?.name?.id);
        console.log("match vecnt", matchEvent)
        if (!matchEvent) return null;
        return {
          ...matchEvent,
          eventId: response._id,
          venue: response?.eventVenue,
          date: response?.eventDate,
          createdBy: response?.createdBy,
          subEvents: response?.subEvents || [],
          location: response?.location || "",
          selectedTheme:
            matchEvent.theme.find((t) => t.id === response.theme?.id) ||
            { id: "custom", name: response.theme?.name },

          selectedDressCode:
            matchEvent.dressCode.find((dc) => dc.id === response.dressCode?.id) ||
            { id: "custom", name: response.dressCode?.name },

          selectedDressColor:
            matchEvent.dressColor.find((col) => col.id === response.dressColor?.id) ||
            { id: "custom", name: response.dressColor?.name },
        };

      });

      console.log("mapped", mappedEvents)
      setEvent(mappedEvents);
      setTotalItems(response?.data?.data.count);
    } catch (error) {
      console.log(error);
    }
    finally {
      setLoader(false);
    }
  };


  useEffect(() => {
    setLoader(true);

    getEvents();
  }, [currentPage]);


  useEffect(() => {
    setCurrentPage(0)
    setLoader(true);

    getEvents();
  }, [filterDate, filterType, endDate, sortBy, sortOrder]);
 const totalPages = Math.ceil(totalItems / itemsPerPage);
  return (
    <div className="qx-page">
      {/* <div className="pb-2 d-flex justify-content-between">
        <input
          type="text"
          style={{ borderRadius: "0.5rem", width: "100%" }}
          className="form-control inpp"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div> */}
      <PageTitle pageTitle="Events" subtitle="Browse and manage all platform events" />
   <Card className="qx-filter-card mb-4">
        <Row className="g-3 qx-filter-grid align-items-end">
          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label className="fw-semibold" style={{ color: "#3F3F46" }}>
                Start Date
              </Form.Label>
              <Form.Control
                type="date"
                value={filterDate}
                onChange={(e) => setFilterDate(e.target.value)}
                style={{ borderRadius: "8px" }}
              />
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label className="fw-semibold" style={{ color: "#3F3F46" }}>
                End Date
              </Form.Label>
              <Form.Control
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                style={{ borderRadius: "8px" }}
              />
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label className="fw-semibold" style={{ color: "#3F3F46" }}>
                Filter by Type
              </Form.Label>
              <Form.Select
                value={filterType}
                onChange={(e) => setFilterType(e.target.value)}
                style={{ borderRadius: "8px" }}
              >
                <option value="">All Types</option>
                <option value="custom">Custom</option>
                <option value="0">Roka</option>
                <option value="1">Engagement</option>
                <option value="2">Haldi</option>
                <option value="4">Sangeet</option>
                <option value="5">Cocktail</option>
                <option value="6">Wedding</option>
                <option value="7">Music Bash</option>
                <option value="3">Mehndi</option>
                <option value="8">Reception</option>
              </Form.Select>
            </Form.Group>
          </Col>

   

          <Col md={4} className="d-flex align-items-end justify-content-md-start justify-content-center">
            {(filterDate || filterType || endDate || sortBy) && (
              <button
                className="btn btn-outline-danger w-100"
                style={{ borderRadius: "8px" }}
                onClick={() => {
                  setFilterDate("");
                  setFilterType("");
                  setEndDate("");
                  setSortBy("");
                  setSortOrder("asc");
                }}
              >
                Clear Filters
              </button>
            )}
          </Col>

        </Row>
      </Card>





      <Card className="qx-table-card">
        <Card.Body>
          <Table responsive>
            <thead>
              <tr>
                <th><strong>S.NO</strong></th>
                <th><strong>Event</strong></th>
                <th><strong>Event Date/Time</strong></th>
                <th><strong>Venue</strong></th>
                <th><strong>Location</strong></th>
                <th><strong>Host Name</strong></th>
                <th><strong>Action</strong></th>
              </tr>
            </thead>
            <tbody>
              {loader ? (
                <TableLoaderRow colSpan={7} />
              ) : !event?.length ? (
                <TableEmptyRow colSpan={7} message="No events found" />
              ) : (
                event.map((tension, index) => (
                    <tr key={tension?.eventId}>
                      <td>{index + 1 + currentPage * itemsPerPage}</td>
                      <td>{tension?.name}</td>
                      <td>
                        {tension?.date
                          ? new Date(tension.date).toLocaleString("en-IN", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                          : "--"}
                      </td>



                      <td>
                        <TruncatedTooltipText text={tension?.venue} limit={40} />
                      </td>
                      <td>
                        <TruncatedTooltipText text={tension?.location} limit={40} />
                      </td>
                      {tension?.createdBy?.hostName ?
                        <td className="cursor-pointer text-blue" onClick={() => navigate(`/user-details/${tension?.createdBy?._id}`)}>{tension?.createdBy?.hostName?.charAt(0).toUpperCase()}{tension?.createdBy?.hostName?.slice(1)} </td> : <td>_</td>}
                      <td>
                        <button
                          type="button"
                          className="qx-action-view"
                          title="View event"
                          aria-label="View event"
                          onClick={() =>
                            navigate(`/event_details/${tension?.eventId}`, {
                              state: { tension },
                            })
                          }
                        >
                          <ChevronRight size={18} strokeWidth={2.5} />
                        </button>
                      </td>
                    </tr>
                ))
              )}
            </tbody>
          </Table>

          {!loader && event?.length > 0 && (
            <Pagination
              pageCount={totalPages}
              pageValue={currentPage}
              setPage={setCurrentPage}
              total={totalItems}
              pageSize={itemsPerPage}
            />
          )}
        </Card.Body>
      </Card>
      <ConfirmationDeleteAccount
        show={deleteAccount}
        onHide={() => setDeleteAccount(false)}
        onDelete={() => { }}
        type="user"
      />
    </div>
  );
}

